import { Component } from '@angular/core';
import { StringWidget as _StringWidget } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';

@Component( {
  selector: 'sp-string-widget',
  templateUrl: './string.widget.html',
} )
export class StringWidget extends _StringWidget {
  schema: JSONSchema;

  get widget() {
    let widget = this.schema.widget;
    return typeof widget === 'string' ? { id: widget } : widget;
  }

  getInputType() {
    if ( !this.widget.id || this.widget.id === 'string' ) {
      return 'text';
    } else {
      return this.widget.id;
    }
  }

  get prefix(): string {
    return ( this.schema.options && this.schema.options.prefix ) || '';
  }

  get suffix(): string {
    return ( this.schema.options && this.schema.options.suffix ) || '';
  }

  get required() {
    return isWidgetRequired( this );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/string.widget.ts